import { IconButton } from "@chakra-ui/react";

import { AddIcon } from "@nens/ranalib";

export const AddIconControl = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton
      icon={<AddIcon color="brand.analytic" />}
      onClick={onClick}
      aria-label="Add a new map"
      boxSize="8"
      minW={8}
      p={3}
      mr={-2}
      borderWidth={0}
      variant="tertiary"
    />
  );
};
